import type { Session } from '../../schemas';
import apiClient from '../index';

export const getSession = async () => {
	const response = await apiClient.get<Session>('/auth/me');
	return response.data;
};

export const getVocabulary = async () => {
	const response = await apiClient.get<{ vocabulary: unknown }>(
		'/reference/vocabulary',
	);
	return response.data.vocabulary;
};

export const signIn = async (email: string, password: string) => {
	const response = await apiClient.post<Session>('/auth/login', {
		email,
		password,
	});
	return response.data;
};

export const signOut = async () => {
	const response = await apiClient.post<void>('/auth/logout');
	return response.data;
};

export const getRegistrationOpen = async () => {
	const response = await apiClient.get<{ open: boolean }>(
		'/auth/registration-open',
	);
	return response.data;
};

export const register = async (input: {
	firmName: string;
	name: string;
	email: string;
	password: string;
}) => {
	const response = await apiClient.post<Session>('/auth/register', input);
	return response.data;
};

export const changePassword = async (
	currentPassword: string,
	newPassword: string,
) => {
	const response = await apiClient.post<void>('/auth/change-password', {
		currentPassword,
		newPassword,
	});
	return response.data;
};

export const acceptInvite = async (input: {
	token: string;
	name: string;
	password: string;
}) => {
	const response = await apiClient.post<Session>(
		'/auth/accept-invite',
		input,
	);
	return response.data;
};

export const forgotPassword = async (input: { email: string }) => {
	const response = await apiClient.post<void>('/auth/forgot-password', input);
	return response.data;
};

export const resetPassword = async (input: {
	token: string;
	password: string;
}) => {
	const response = await apiClient.post<void>('/auth/reset-password', input);
	return response.data;
};
